import { esperar } from '@/shared/utils/esperar';

import { gerarDashboardAtendimentoMock } from '../../lib/mockDataDashboardAtendimento';
import type {
  DashboardAtendimentoData,
  PeriodoDashboardAtendimento,
} from '../../types/dashboardAtendimento';

/** Sem latência o estado de carregamento nunca aparece, e não dá para avaliá-lo na tela. */
const ATRASO_DO_MOCK_MS = 450;

export const dashboardAtendimentoService = {
  // TODO: trocar pelo `GET /admin/atendimento/dashboard?periodo=` quando o backend entregar; o
  // mock já devolve o formato do contrato, então a troca é só aqui.
  async get(
    periodo: PeriodoDashboardAtendimento,
    signal?: AbortSignal,
  ): Promise<DashboardAtendimentoData> {
    await esperar(ATRASO_DO_MOCK_MS, signal);
    return gerarDashboardAtendimentoMock(periodo);
  },
};
